import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Text$1 from '../../basics/Text/Text.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import StyledCaption from './Caption.style.js';

const Caption = (_ref) => {
  let {
    caption,
    rotateTo,
    inverse,
    isVisible,
    credits
  } = _ref,
      props = _objectWithoutProperties(_ref, ["caption", "rotateTo", "inverse", "isVisible", "credits"]);

  const captionMeta = `
    <span class="caption__fig">
      <svg width="14" height="13" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 13">
        <path d="M0 13L6.577 0l6.547 13H0zm2.922-1.802h7.28L6.57 3.988l-3.648 7.21z" fill-rule="evenodd" />
      </svg>
    </span>`;
  return /*#__PURE__*/React$1.createElement(StyledCaption, _extends({
    rotateTo: rotateTo,
    isVisible: isVisible,
    inverse: inverse
  }, props), caption && /*#__PURE__*/React$1.createElement(Text$1, {
    content: `${captionMeta}${caption}`,
    className: "caption__caption"
  }), credits && /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "small",
    className: "caption__credits"
  }, credits));
};

Caption.propTypes = {
  caption: PropTypes$1.string,
  credits: PropTypes$1.string,
  rotateTo: PropTypes$1.string,
  isVisible: PropTypes$1.bool,
  inverse: PropTypes$1.bool
};
Caption.defaultProps = {
  isVisible: false,
  rotateTo: 'right',
  caption: null,
  credits: null,
  inverse: false
};

export default Caption;
